"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = void 0;
exports.useExpandsStatus = useExpandsStatus;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/createForOfIteratorHelper"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread4 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = require("react");
var expands = {};
var listeners = [];
var store = {
  collapse: function collapse(id) {
    expands = (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, expands), {}, (0, _defineProperty2["default"])({}, id, false));
    emitChange();
  },
  expand: function expand(id) {
    expands = (0, _objectSpread4["default"])((0, _objectSpread4["default"])({}, expands), {}, (0, _defineProperty2["default"])({}, id, true));
    emitChange();
  }
};
exports.store = store;
function getSnapshot() {
  return expands;
}
function subscribe(listener) {
  listeners = [].concat((0, _toConsumableArray2["default"])(listeners), [listener]);
  return function () {
    listeners = listeners.filter(function (l) {
      return l !== listener;
    });
  };
}
function emitChange() {
  var _iterator = (0, _createForOfIteratorHelper2["default"])(listeners),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var listener = _step.value;
      listener();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function useExpandsStatus() {
  var expands = (0, _react.useSyncExternalStore)(subscribe, getSnapshot);
  return expands;
}